import CreateEssentialQuestionsView from "@features/tools/view/essential-questions-view/create-essential-questions-view";

const CreateEssentialQuestions = () => {
  return <CreateEssentialQuestionsView />;
};

export default CreateEssentialQuestions;
